import { Component, OnInit } from '@angular/core';
import {
  overviewFilters,
  overviewStatistics,
  stringsList,
} from '../../constants/app-config';
import { StatisticsService } from '../services/statistics.service';
import { OverviewService } from '../services/overview.service';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { StatisticsScanData } from '../models/statisticsScans.model';
import { log } from 'console';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css', '../../styles/styles.css'],
})
export class OverviewComponent implements OnInit {
  overviewFilters = overviewFilters;
  overviewStatistics = overviewStatistics;
  stringsList = stringsList;
  legend: boolean = false;
  showLabels: boolean = true;
  filter: number = 0;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = false;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  timeline: boolean = true;
  multi: any = [];
  colorScheme: Color = {
    domain: ['#CAE88C'],
    name: 'myScheme',
    selectable: true,
    group: ScaleType.Ordinal,
  };
  loading: boolean = false;
  revenue: number = 0;
  scansAmount: number = 0;
  scans: number = 0;
  statisticsScansData!: StatisticsScanData;
  selectedGraphName: string = 'Revenue';
  clientsNumber: number = 0;
  isThereDataInLocalStorage: boolean = false;

  revenueGraphData: any;
  clientsGraphData: any;
  scansGraphData: any;
  isScletonLoaderVisible: boolean = false;

  constructor(private StatisticsService: StatisticsService) {}

  ngOnInit(): void {
    this.loading = true;
    this.getStatistics();
  }

  async getStatistics() {
    await this.checkIfThereIsDataInLocalStorage();

    this.StatisticsService.GetStatistics()
      .then((res) => {
        if (typeof res.scans === 'string') {
          if (
            JSON.parse(
              JSON.stringify(localStorage.getItem('statisticsScansData'))
            ) !== JSON.parse(JSON.stringify(res.scans))
          ) {
            this.statisticsScansData = JSON.parse(res.scans);
            this.isScletonLoaderVisible = false;
            localStorage.setItem(
              'statisticsScansData',
              JSON.stringify(this.statisticsScansData)
            );
          }
        }
        this.setNumbersAndGraphs();
      })
      .catch((err) => console.log(err));
  }

  async checkIfThereIsDataInLocalStorage() {
    const storedStatisticsScansData = localStorage.getItem(
      'statisticsScansData'
    );

    if (storedStatisticsScansData) {
      this.statisticsScansData = JSON.parse(storedStatisticsScansData);
      this.setNumbersAndGraphs();
      this.isThereDataInLocalStorage = true;
      this.isScletonLoaderVisible = false;
    } else {
      this.isThereDataInLocalStorage = false;
      this.isScletonLoaderVisible = true;
    }
  }

  selectButton(event: any) {
    this.overviewFilters.forEach((filter) => {
      if (filter.key !== event.text) filter.isButtonSelected = false;
    });
  }

  onSelectFilter(filterNum: number): void {
    this.filter = filterNum;
    this.setNumbersAndGraphs();
  }

  getNumberOfIncreaseOfScans() {
    const months = this.statisticsScansData?.graph?.last_12_months;
  
    // Get the keys (months) and sort them
    const sortedMonths = Object.keys(months).sort();
  
    // Get the values (number of scans) for the last two months
    const lastMonthValue = months[sortedMonths[sortedMonths.length - 2]];
    const currentMonthValue = months[sortedMonths[sortedMonths.length - 1]];

    console.log('lastMonthValue', lastMonthValue);
    console.log('currentMonthValue', currentMonthValue);
    
    
  
    // Calculate the percentage change
    const percentageChange = ((currentMonthValue - lastMonthValue) / lastMonthValue);

    console.log('percentageChange.toFixed(2)', percentageChange);

    if(lastMonthValue == 0 && currentMonthValue > 0){
      return '100'
    }
    
    return percentageChange.toFixed(2);

  }

  isGraphTextString(): boolean {
    return this.getGraphBelowTextName().length > 5;
  }
  

  getGraphBelowTextName() {
    if (this.filter === 0) {
      return 'Total overview';
    } else if (this.filter === 1) {
      return 'Yearly overview';
    } else if (this.filter === 2) {
      // this.getNumberOfIncreaseOfScans()
      if (this.selectedGraphName !== 'Scans') return 'Monthly overview'; // Corrected variable name
      const percentageChange = this.getNumberOfIncreaseOfScans();
      if (parseFloat(percentageChange) > 0) {
        // Perform the desired action
        return percentageChange;
      }else{
        return 'Monthly overview'
      }
    } else if (this.filter === 3) {
      return 'Weekly overview';
    }
    return '';
  }
   
  
  
  
  
  

  setNumbersAndGraphs() {
    switch (this.filter) {
      case 0:
        this.multi = this.defineNumbersAndGraphFotTotalFilter();
        break;
      case 1:
        this.multi = this.defineNumbersAndGraphFotYearFilter();
        break;
      case 2:
        this.multi = this.defineNumbersAndGraphFotMonthFilter2();
        break;
      case 3:
        this.multi = this.defineNumbersAndGraphFotWeekFilter();
        break;
      default:
        this.multi = this.defineNumbersAndGraphFotTotalFilter();
    }
  }

  defineNumbersAndGraphFotTotalFilter() {
    this.scans = this.statisticsScansData.numbers.total;
    this.revenue = this.scans * 0.33;
    this.revenueGraphData = this.StatisticsService.getTotalGraph(
      this.statisticsScansData.graph.total,
      'Revenue'
    );
    this.scansGraphData = this.StatisticsService.getTotalGraph(
      this.statisticsScansData.graph.total,
      'Scans'
    );

    if (this.selectedGraphName == 'Scans') {
      this.multi = this.scansGraphData;
      return this.scansGraphData;
    } else if (this.selectedGraphName == 'Clients') {
      this.multi = this.clientsGraphData;
      return this.clientsGraphData;
    } else {
      this.multi = this.revenueGraphData;
      return this.revenueGraphData;
    }
  }

  defineNumbersAndGraphFotYearFilter() {
    this.scans = this.statisticsScansData.numbers.last_12_months;
    this.revenue = this.scans * 0.33;
    this.revenueGraphData = this.StatisticsService.getYearGraph(
      this.statisticsScansData.graph.last_12_months,
      'Revenue'
    );
    this.scansGraphData = this.StatisticsService.getYearGraph(
      this.statisticsScansData.graph.last_12_months,
      'Scans'
    );

    if (this.selectedGraphName == 'Scans') {
      this.multi = this.scansGraphData;
      return this.scansGraphData;
    } else if (this.selectedGraphName == 'Clients') {
      this.multi = this.clientsGraphData;
      return this.clientsGraphData;
    } else {
      this.multi = this.revenueGraphData;
      return this.revenueGraphData;
    }
  }

  defineNumbersAndGraphFotMonthFilter2() {
    this.scans = this.statisticsScansData.numbers.last_30_days;
    this.revenue = this.scans * 0.33;
    this.revenueGraphData = this.StatisticsService.getMonthGraph(
      this.statisticsScansData.graph.last_30_days,
      'Revenue'
    );
    this.scansGraphData = this.StatisticsService.getMonthGraph(
      this.statisticsScansData.graph.last_30_days,
      'Scans'
    );

    if (this.selectedGraphName == 'Scans') {
      this.multi = this.scansGraphData;
      return this.scansGraphData;
    } else if (this.selectedGraphName == 'Clients') {
      this.multi = this.clientsGraphData;
      return this.clientsGraphData;
    } else {
      this.multi = this.revenueGraphData;
      return this.revenueGraphData;
    }
  }

  defineNumbersAndGraphFotWeekFilter() {
    this.scans = this.statisticsScansData.numbers.last_7_days;
    this.revenue = this.scans * 0.33;
    this.revenueGraphData = this.StatisticsService.getWeekGraph(
      this.statisticsScansData.graph.last_7_days,
      'Revenue'
    );

    this.scansGraphData = this.StatisticsService.getWeekGraph(
      this.statisticsScansData.graph.last_7_days,
      'Scans'
    );

    if (this.selectedGraphName == 'Scans') {
      this.multi = this.scansGraphData;
      return this.scansGraphData;
    } else if (this.selectedGraphName == 'Clients') {
      this.multi = this.clientsGraphData;
      return this.clientsGraphData;
    } else {
      this.multi = this.revenueGraphData;
      return this.revenueGraphData;
    }
  }

  selectGraphName(graphName: string) {
    this.selectedGraphName = graphName;
    this.setNumbersAndGraphs();
    if (graphName == 'Scans') {
      this.multi = this.scansGraphData;
    } else if (graphName == 'Clients') {
      this.multi = this.clientsGraphData;
    } else {
      this.multi = this.revenueGraphData;
    }
  }

  getSelectedGraphName(selectedGraphName: string) {
    if (selectedGraphName === 'Revenue') {
      return 'Expenses';
    } else {
      return selectedGraphName;
    }
  }
}
